import React from "react";
import { cn } from "../../lib/cn";

const WIDTHS = {
  default: "max-w-container",
  narrow: "max-w-3xl",
  wide: "max-w-[1440px]",
  prose: "max-w-prose",
};

/** Centered page width with consistent gutters. */
export function Container({ width = "default", className, children, ...props }) {
  return (
    <div className={cn("mx-auto w-full px-5 sm:px-8", WIDTHS[width], className)} {...props}>
      {children}
    </div>
  );
}

export default Container;
